import { render, staticRenderFns } from "./ProductsMain.vue?vue&type=template&id=16eb103e&"
import script from "./ProductsMain.vue?vue&type=script&lang=js&"
export * from "./ProductsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports